import { call } from '../../shared/api.ts'
import type { apiDto } from '@rs/contracts'

/**
 * ══ CỬA GỌI REST — MẬT KHẨU CỦA NHÂN SỰ NỘI BỘ (E13 sửa 19/10/2026) ══════════════════════════════════════════════
 * Kiểu lấy từ hợp đồng (§12.3). `resetUserPasswordApi` là chỗ DUY NHẤT mật khẩu tạm của nhân sự đi qua trình duyệt — màn
 * hiện nó một lần rồi bỏ, KHÔNG cất vào kho truy vấn hay `localStorage` (cùng luật `vendor-users-api.ts`).
 */
export type PasswordState = apiDto.PasswordStateDto

export const fetchPasswordState = (): Promise<PasswordState> => call<PasswordState>('/api/v1/auth/mat-khau')

/** `oldPassword` chỉ gửi khi tài khoản ĐÃ có mật khẩu — máy chủ tự kiểm. */
export const changeOwnPasswordApi = (body: { oldPassword?: string; newPassword: string }): Promise<{ ok: true }> =>
  call<{ ok: true }>('/api/v1/auth/doi-mat-khau', { method: 'POST', body: JSON.stringify(body) })

export const resetUserPasswordApi = (userId: string): Promise<apiDto.UserTempPasswordDto> =>
  call<apiDto.UserTempPasswordDto>(`/api/v1/catalog/users/${userId}/cap-lai-mat-khau`, { method: 'POST', body: '{}' })
